@let optionText = choiceOption().text;

<ap-button [type]="'button'" [ariaLabel]="optionText" (onClick)="onSelectOption()">{{ optionText }}</ap-button>
